import type { ReactNode } from 'react';
import type { SimpleSearchFilter } from 'api/dashboard/widget';
import { User } from 'api/models';

export enum ViewType {
  ProjectList = 'PROJECT_LIST',
  ProjectTaskList = 'PROJECT_TASK_LIST',
  AllTasks = 'ALL_TASKS',
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  ResourceManagementCapacityPlanning = 'CAPACITY_PLANNING',
  TimesheetReports = 'TIMESHEET_REPORTS',
  CsatReports = 'CSAT_REPORTS',
  ProjectPerformanceReports = 'PROJECT_PERFORMANCE_REPORTS',
  PeoplePerformanceReports = 'PEOPLE_PERFORMANCE_REPORTS',
  OperationReports = 'OPERATION_REPORTS',
  IntervalIqReports = 'INTERVAL_IQ_REPORTS',
  ProfitabilityReports = 'PROFITABILITY_REPORTS',
  Dashboard = 'DASHBOARD_FILTER',
  UtilizationReport = 'UTILIZATION_REPORT',
  TimesheetSubmissionReport = 'TIMESHEET_SUBMISSION_REPORT',
  UserTimeAnalyticsReport = 'USER_TIME_ANALYTICS_REPORT',
  ProjectTimeAnalyticsReport = 'PROJECT_TIME_ANALYTICS_REPORT',
  CateogryTimeAnalyticsReport = 'CATEGORY_TIME_ANALYTICS_REPORT',
  SprintList = 'SPRINT_LIST',
  SprintReports = 'SPRINT_REPORT',
  CustomerPorfolioList = 'COMPANY_LIST',
  CustomReport = 'CUSTOM_REPORT',
  SkillMatrix = 'SKILL_MATRIX',
  ResourceRequest = 'RESOURCE_REQUEST',
  ResourceApproval = 'RESOURCE_APPROVAL',
  InvoiceList = 'INVOICE_LIST',
  CreditNoteList = 'CREDIT_NOTE_LIST',
  TimesheetApprovals = 'TIMESHEET_APPROVALS',
  ProjectTimesheetsList = 'PROJECT_TIMESHEETS_LIST',
  TimesheetsList = 'ACCOUNT_TIMESHEETS_LIST',
  EpicList = 'EPIC_LIST',
  BacklogList = 'BACKLOG_LIST',
  MyExpenses = 'MY_EXPENSES',
  ExpenseApprovals = 'EXPENSE_APPROVALS',
  ProjectExpenses = 'PROJECT_EXPENSES',
  MyExpenseReports = 'MY_EXPENSE_REPORTS',
  ExpenseApprovalReports = 'EXPENSE_APPROVAL_REPORTS',
  // using this for both revenue overview and list page
  RevenueView = 'REVENUE_VIEW',
  AllSignal = 'ALL_SIGNAL',
}

type ViewFilterShareConfigType = {
  sharedWithCustomerPortal: boolean;
  shareWithProjects?: boolean;
  shareWithAllProjects?: boolean;
  filter?: SimpleSearchFilter;
};

export enum ViewScopeType {
  Self = 'SELF',
  Limited = 'LIMITED',
  Everyone = 'EVERYONE',
}

export interface View<ViewDefinition> {
  viewId: number;
  viewName: string;
  viewDefinition: ViewDefinition;
  viewIcon?: ReactNode;
  createdBy: number;
  viewType: ViewType;
  self: boolean;
  hidden?: boolean; // User-level customisation
  viewSourceId?: number;
  viewFilterShareConfig?: ViewFilterShareConfigType;
  restrictedIds?: number[];
  userGroupIds?: number[];
  restrictedUsers?: User[];
  scopeType: ViewScopeType;
}

export interface ViewCustomisationUpdate {
  viewId: number;
  hidden?: boolean;
  position?: number;
}

export interface ViewCustomisationPayload {
  viewType: ViewType;
  viewSourceId: number | null;
  shared: boolean;
  updates: ViewCustomisationUpdate[];
}
